import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=35df40ae&scoped=true&"
import script from "./UserCard.vue?vue&type=script&lang=js&"
export * from "./UserCard.vue?vue&type=script&lang=js&"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=35df40ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35df40ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35df40ae')) {
      api.createRecord('35df40ae', component.options)
    } else {
      api.reload('35df40ae', component.options)
    }
    module.hot.accept("./UserCard.vue?vue&type=template&id=35df40ae&scoped=true&", function () {
      api.rerender('35df40ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fwpt/profile/components/UserCard.vue"
export default component.exports